export default "__VITE_ASSET__c8355cf4__"